import React from 'react';
import { Countdown } from './Countdown';
import { ANCHOR_PRICE } from '../lib/config';
export function Urgency() {
  return <section className="w-full bg-ink py-16 sm:py-20" data-id="element-352" data-mp="2bvcwml61ownb">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-353" data-mp="1wzng32jmpbpz">
        <p className="text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-354" data-mp="1wz5c1jqq5t7i">
          Launch price — ends in
        </p>

        <div className="mt-8" data-id="element-355" data-mp="220b5jjs7lki3">
          <Countdown tone="dark" data-id="element-356" data-mp="1o6ju25ux3qjq" />
        </div>

        <p className="mt-8 text-base text-ivory/80" data-id="element-357" data-mp="1o5sbbvmf5nav">
          Then it goes to the regular price of{' '}
          <span className="font-serif text-xl text-gold" data-id="element-358" data-mp="1szwhicnv1raw">{ANCHOR_PRICE}</span>. For good.
        </p>

        <p className="mx-auto mt-8 max-w-xl border-t border-gold/25 pt-8 font-serif text-xl italic leading-snug text-ivory" data-id="element-359" data-mp="1e6t148m09jlr">
          Wedding this Saturday? The download is instant — you can print the shot lists
          tonight.
        </p>
      </div>
    </section>;
}